import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import ImageScroller from '../../components/imagescroller';
import ClipboardCopy from '../../components/gui/clipboardCopy';

import localUtil from '../../lib/util';
import { appAlert, appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

@observer
class NewsMenu extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            sharing: false,
        };
        this.mainContainer = null;
    }

    // loadAll = async (props = this.props) => {
    //     const { id } = props;
    //     const { newsStore } = this.props.stores;
    //     if (id) {
    //         newsStore.updateKeyValue('news', {});
    //         await newsStore.load(id, false, { addData: ['tags'] });
    //     }
    // }

    editNews = () => {
		const { news, drawerLevel } = this.props;
		const { appState } = this.props.stores;
		const { drawerHeightMedium } = appState;
		appState.openDrawer('newsEdit', {
			height: drawerHeightMedium,
			id: news.id,
		}, drawerLevel + 1);
	}

    viewInstallation = e => {
        const { id } = e.currentTarget.dataset;
        const { appState } = this.props.stores;
        appState.toggleDrawer();
        route(`/installation/${id}`);
    };

    shareToFacebook = () => {
        const { news } = this.props;
        const { appState } = this.props.stores;
        const { userStore } = this.props.stores;
        const { user } = userStore;
        const { title, text, image } = news;

        // 1) fallbacks so you don't end up with "undefined"
        // const sharePath = `/share/news/${news.uuidv4}?domain=${window.location?.hostname}&target=race`;
        const sharePath = `/share/news/${news.uuidv4}`;
        const pageUrl  = window.location.origin + (sharePath || '/');
        const quote    = title || ''; // no undefined

        // 2) encode each piece only once
        const params = new URLSearchParams({
            u:      pageUrl,
            quote:  quote,
        }).toString();

        console.log('Sharing to Facebook:', params);

        const fbUrl = 'https://www.facebook.com/sharer/sharer.php?' + params;
        window.open(fbUrl, 'fbshare', 'width=600,height=400');
    }

    shareToFeed = async () => {
        const dialogAction = beginDialogAction(this, 'shareToFeed', () => [
            this.props?.news?.id,
        ]);
        if (!dialogAction) return false;
        try {
            const { news } = this.props;
            const { appState, raceStore } = this.props.stores;
            const { isRaceAdmin } = raceStore;

            const confirmMsg = isRaceAdmin
                ? 'Share this news to the main feed as the race?'
                : 'Share this news to the main feed?';

            if (!((await appConfirm(confirmMsg)) && dialogAction.isCurrent())) {
                return;
            }

            this.setState({ sharing: true });

            try {
                const response = await util.fetchApi(`/api/news/${news.id}/share-to-feed`, {
                    method: 'POST',
                }, {
                    raceId: news.race,
                });

                if (response.status === 200) {
                    (await appAlert('News shared to feed successfully!'));
                    if (!dialogAction.isCurrent()) return;
                    appState.toggleDrawer();
                } else {
                    (await appAlert(response.message || 'Failed to share news to feed'));
                }
            } catch (err) {
                console.error('Error sharing to feed:', err);
                (await appAlert('Error sharing news to feed'));
            } finally {
                this.setState({ sharing: false });
            }
        } finally {
            dialogAction.finish();
        }
    }

    // componentDidMount() {
    //     this.loadAll();
    // }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    componentWillUnmount() {

    }

    render() {
        const {
            page,
            artid,
            bib,
            showAnimations = true,
            news = {},
        } = this.props;
        const { sessionid, showMenu } = this.state;
        const { appState, userStore, newsStore, raceStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const { isRaceAdmin } = raceStore;

        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='w-100 d-flex flex-column'>
                        <div class='px-0 box-header-info d-flex flex-column'>
                            <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                <div class='d-flex flex-row justify-content-between'>
                                    {(isAdmin || isRaceAdmin) && <>
                                        <button
                                            class='btn btn-sm btn-primary rounded-pill me-2'
                                            onClick={this.editNews}
                                        >
                                            <i class='fa-solid fa-edit me-2' /> <Text id='news.edit' />
                                        </button>
                                    </>}
                                    <button
                                        class='btn btn-sm btn-outline-secondary rounded-pill me-2'
                                        onClick={this.shareToFacebook}
                                    >
                                        <i class='fa-brands fa-square-facebook me-2' /> <Text id='news.share-to-facebook'>Share to Facebook</Text>
                                    </button>
                                    <button
                                        class='btn btn-sm btn-outline-primary rounded-pill'
                                        onClick={this.shareToFeed}
                                        disabled={this.state.sharing}
                                    >
                                        <i class={`fa-solid ${this.state.sharing ? 'fa-spinner fa-spin' : 'fa-share-from-square'} me-2`} />
                                        <Text id='news.share-to-feed'>Share to Feed</Text>
                                    </button>
                                </div>

                                <div class='d-flex flex-row justify-content-center align-items-center mt-3'>
                                    <small class=''>
                                        <ClipboardCopy
                                            label={<><i class='fa-duotone fa-share' /> <Text id='article.share'>Share article</Text></>}
                                            text={`${window.location.protocol}//${window.location?.hostname}${window.location.port ? `:${window.location.port}` : ''}/share/news/${news.uuidv4}?domain=${window.location?.hostname}${window.location.port ? `:${window.location.port}` : ''}&target=race`}
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <SimpleBlog stores={this.props.stores} {...this.props} /> */}
                </div>
            </div>
        </>);
    }
}

export default NewsMenu;
